import {
  LBButton,
  LBDialogFooter,
  LBLabel,
  LBRadioGroup,
  LBRadioGroupItem
} from '@linearb/buzz';
import { useState } from 'react';
import DeleteFooter from './DeleteFooter';
import DeleteConfirmation from './DeleteConfirmation';

const STEPS = {
  SELECT_DELETION_TYPE: 'SELECT_DELETION_TYPE',
  DELETE_CONFIRMATION: 'DELETE_CONFIRMATION'
};

const DELETION_TYPES = {
  DELETE_WITH_DATA: 'DELETE_WITH_DATA',
  DELETE_WITHOUT_DATA: 'DELETE_WITHOUT_DATA'
};

const deletionTypesOptions = [
  {
    value: DELETION_TYPES.DELETE_WITH_DATA,
    name: 'Remove everything',
    description:
      'Integration and all associated historical data will be permanently deleted. This cannot be undone.'
  },
  {
    value: DELETION_TYPES.DELETE_WITHOUT_DATA,
    name: 'Keep data',
    description: 'Stop integration, keep all historical data'
  }
];

const HasDataForm = ({ onDeleteWithData, onDeleteWithoutData }) => {
  const [step, setStep] = useState(STEPS.SELECT_DELETION_TYPE);
  const [deletionType, setDeletionType] = useState(
    DELETION_TYPES.DELETE_WITH_DATA
  );

  return (
    <div>
      {step === STEPS.SELECT_DELETION_TYPE && (
        <>
          <LBRadioGroup value={deletionType} onValueChange={setDeletionType}>
            {deletionTypesOptions.map(option => {
              return (
                <div className='flex items-start gap-2' key={option.value}>
                  <LBRadioGroupItem
                    id={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  />

                  <div className='flex flex-col items-start'>
                    <LBLabel className='text-sm' htmlFor={option.value}>
                      {option.name}
                    </LBLabel>
                    <div className='text-muted-foreground text-sm'>
                      {option.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </LBRadioGroup>
          <LBDialogFooter className='mt-8'>
            <LBButton onClick={() => setStep(STEPS.DELETE_CONFIRMATION)}>
              Next
            </LBButton>
          </LBDialogFooter>
        </>
      )}

      {step === STEPS.DELETE_CONFIRMATION && (
        <>
          {deletionType === DELETION_TYPES.DELETE_WITH_DATA && (
            <DeleteConfirmation onDelete={onDeleteWithData} />
          )}
          {deletionType === DELETION_TYPES.DELETE_WITHOUT_DATA && (
            <DeleteFooter onDelete={onDeleteWithoutData} />
          )}
        </>
      )}
    </div>
  );
};

export default HasDataForm;
